import React, { createContext, useContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    type: 'info',
    message: '',
    duration: 6000,
  });

  const showAlert = (message, type = 'info', duration = 6000) => {
    setAlert({
      open: true,
      type,
      message,
      duration,
    });
  };

  const hideAlert = () => {
    setAlert(prev => ({
      ...prev,
      open: false,
    }));
  };

  // Funções de conveniência
  const showSuccess = (message, duration) =>
    showAlert(message, 'success', duration);
  const showError = (message, duration) =>
    showAlert(message, 'error', duration);
  const showInfo = (message, duration) => showAlert(message, 'info', duration);
  const showWarning = (message, duration) =>
    showAlert(message, 'warning', duration);

  const value = {
    showAlert,
    hideAlert,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };

  return (
    <AlertContext.Provider value={value}>
      {children}
      <Snackbar
        open={alert.open}
        autoHideDuration={alert.duration}
        onClose={hideAlert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={hideAlert}
          severity={alert.type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export default AlertContext;
